<template>
<svg focusable="false" width="16px" height="16px" viewBox="0 0 32 32">
    <path d="M12 8l10 8l-10 8z" fill="currentColor" />
</svg>
</template>

<script lang="ts">
import {
    defineComponent
} from "vue";

export default defineComponent({
    name: 'CaretRight'
})
</script>
